define(function(require){
    'use strict';

    var Marionette  = require('marionette');
    var BasePopover = require('popovers/_base/view');
    var BodyView    = require('popovers/staff_select/view/body');
    var StaffCollection    = require('collections/staffs');

    return BasePopover.extend({
        initialize: function(options) {
            BasePopover.prototype.initialize.call(this, options);
            this.staffCollection = new StaffCollection();
            this.listenTo(this.staffCollection, 'sync', this.render);
            this.staffCollection.fetch();
        },
        /*
        *   function onBeforeRender()
        *   Event onBeforeRender
        */
        onBeforeRender : function(){
            this.model.set({
                'placement' : "bottom" ,
                'show_footer' : false ,
                'show_header' : false ,
                'width'     : '250px',
                'height'    : '300px'
            });
        },

        /*
        *   function showBody()
        *   Show body
        */
        showBody: function(){
            var body = new BodyView({ model: this.model, collection: this.staffCollection});
            this.regionBody.show(body);

            this.$('.popover-body').scrollbar();

            $('.js-table-parent.scroll-content, .b-card__fields').scroll(function () {
                app.Vents.trigger('datatable:scroll');
            });
        },

        // View ui elements
        ui: {
            siteLinks : '.here-tel-online-site'
        },

        // View events
        events : {
            'click @ui.siteLinks' : 'changeLink'
        } ,

        /*
        *   function changeLink()
        *   Change phone site_id
        *   @param  {event} event
        */
        changeLink: function(event){
            var target  = $(event.currentTarget);
            var data    = target.data();
            var employee = this.staffCollection.get(data.id);
            // Hide popover
            this.hide();
            this.trigger('employee:selected', employee);
        }
    });

 });
